import { SCREENS } from "../../../constants";
import { useWidth } from "../../../hooks/useWidth";
import "./style.css";

const HowItWorks = () => {
  const { width } = useWidth();

  const isMobile = width < SCREENS.TABLET;

  return (
    <section id="how-it-works" className="container mb-5">
      <h3 className="display-6 text-theme text-center mt-5 fw-bold">How it Works</h3>
      <div className="d-flex justify-content-center flex-wrap" style={{ marginTop: isMobile ? "100px" : "" }}>
        <div className="d-flex justify-content-center align-items-center flex-column device-vid-desc mx-3">
          <h3 className="text-center text-theme">You have a brilliant idea🚀 </h3>
          <p className="text-center text-theme w-75">Fill a form telling YUDL about the idea and its potential users</p>
        </div>
        <div className="">
          <video src="/assets/landing/device-vid.mov" className="device-vid mx-3" autoPlay loop muted></video>
        </div>
      </div>

      <div className="d-flex justify-content-center flex-wrap" style={{ marginTop: isMobile ? "20px" : "-150px" }}>
        <div className="">
          <img src="/assets/landing/screen-neuro.gif" alt="" className="device-vid mx-3" />
        </div>
        <div className="d-flex justify-content-center align-items-center flex-column mx-2 order-first order-xl-1">
          <h3 className="text-center text-theme">Your idea turned design ⚡️</h3>
          <p className="text-center text-theme w-75">
            We employ artificial intelligence to convert your idea into designs
          </p>
        </div>
      </div>

      <div className="d-flex justify-content-center flex-wrap" style={{ marginTop: isMobile ? "-70px" : "-200px" }}>
        <div className="d-flex justify-content-center align-items-center flex-column  mx-2 mt-5">
          <h3 className="text-center text-theme mt-5">Your idea, your product 🖥</h3>
          <p className="text-center text-theme w-75">
            You can preview your designs, edit futher and export to popular file formats
          </p>
          <div className="d-flex justify-content-center mt-3">
            <img src="/assets/landing/export-formats.png" alt="" />
          </div>
        </div>
        <div className="">
          <img
            src="/assets/landing/phone-stats.gif"
            alt=""
            className="device-vid mx-3"
          />
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
